<script setup lang="ts">
const { state: previewState, setFadeOnDwell } = usePreview()
</script>

<template>
  <dropdown-menu class="preview-mode-dropdown-menu">
    <menu-section>
      <menu-header label="Options" />
      <dropdown-item @click="setFadeOnDwell(!previewState.previewFadeOnDwell)">
        Fade UI on mouse dwell
        <template #action>
          <menu-checkbox :checked="previewState.previewFadeOnDwell" size="xs" />
        </template>
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item disabled shortcut="⌘Z">
        Undo
      </dropdown-item>
      <dropdown-item disabled shortcut="⇧⌘Z">
        Redo
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item disabled shortcut="⇧⌘S">
        Save
      </dropdown-item>
    </menu-section>
  </dropdown-menu>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.preview-mode-dropdown-menu
  @apply w-60
</style>
